import { useEffect } from 'react';
import styles from '../../styles/root.module.css';
import ChannelConnection from '../../js/connection/ChannelConnection';

type Props = {
    connection: ChannelConnection;
};

export default function RootOverflowHandler({ connection }: Props) {
    useEffect(() => {
        function onViewFocus(data: any) {
            const rootElement = document.getElementById('root');
            if (rootElement) {
                if (data) {
                    // User is pinned - apply restrictions
                    rootElement.className = styles.rootPinned;
                    document.body.style.overflow = 'hidden';
                    document.body.style.position = 'fixed';
                    document.body.style.width = '100%';
                    document.body.style.height = '100%';
                    document.body.style.top = '0';
                    document.body.style.left = '0';
                    
                    // Prevent iOS bounce
                    document.addEventListener('touchmove', preventScroll, { passive: false });
                } else {
                    // No user is pinned - restore normal behavior
                    rootElement.className = styles.root;
                    document.body.style.overflow = '';
                    document.body.style.position = '';
                    document.body.style.width = '';
                    document.body.style.height = '';
                    document.body.style.top = '';
                    document.body.style.left = '';
                    
                    // Remove touch event prevention
                    document.removeEventListener('touchmove', preventScroll);
                }
            }
        }

        function preventScroll(e: TouchEvent) {
            // Only prevent default if it's a scroll event
            if (e.touches.length > 1) {
                e.preventDefault();
            }
        }

        connection.events.addListener('onviewfocus', onViewFocus);

        return () => {
            connection.events.removeListener('onviewfocus', onViewFocus);
            // Clean up any remaining event listeners
            document.removeEventListener('touchmove', preventScroll);
            // Restore normal behavior
            document.body.style.overflow = '';
            document.body.style.position = '';
            document.body.style.width = '';
            document.body.style.height = '';
            document.body.style.top = '';
            document.body.style.left = '';
        };
    }, [connection]);

    return null;
} 